import React, { useEffect, useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import { useMytaverseEvent } from '../../../providers';
import { useMytaStreams } from './MytaStreamsProvider';
import LoadingCinema from './LoadingCinema';
import { useEventContext } from '@providers/EventProvider';
import { useConference } from '../Dolby';
import { useStyles } from '../CoreWeave/styles';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

export const PixelStreamingWrapper = () => {
  const videoParent = useRef<HTMLDivElement>(null);
  const {
    currentRoom,
    sharingWindowFullsceen,
    setSharingWindowFullscreen,
    handleMinimizeSharingScreen,
    isMinimizedScreenSharing,
  } = useMytaverseEvent();
  const { mytaLoading, dataChannelOpened, playStream, rootElement } =
    useMytaStreams();
  const { setIsEventRun } = useEventContext();

  const { screenMediaStreams } = useConference();
  const classes = useStyles();

  useEffect(() => {
    if (
      mytaLoading ||
      !videoParent.current ||
      !rootElement ||
      !dataChannelOpened ||
      !playStream
    ) {
      return;
    }

    videoParent.current.appendChild(rootElement);
  }, [
    mytaLoading,
    dataChannelOpened,
    rootElement,
    videoParent,
    playStream,
    currentRoom,
  ]);

  useEffect(() => {
    if (playStream) {
      setIsEventRun(true);
      window.dispatchEvent(new Event('resize'));
    }
  }, [playStream]);

  return (
    <>
      {currentRoom ? (
        <Box
          id="mytaStreamsWrapper"
          sx={{
            width: '100vw',
            height: '100vh',
            position: 'relative',
            zIndex: playStream ? 10 : -10,
            display: playStream ? 'block' : 'hidden',
          }}
          ref={videoParent}
        ></Box>
      ) : null}

      {currentRoom && screenMediaStreams.length && !isMinimizedScreenSharing ? (
        <>
          <IconButton
            sx={classes.fullscreen}
            id="gameFull"
            onClick={setSharingWindowFullscreen}
          >
            {sharingWindowFullsceen ? (
              <FullscreenExitIcon />
            ) : (
              <FullscreenIcon />
            )}
          </IconButton>
          <IconButton
            sx={classes.fullscreenCollapse}
            id="gameCollapse"
            onClick={handleMinimizeSharingScreen}
          >
            <CloseFullscreenIcon />
          </IconButton>
        </>
      ) : null}

      {!playStream ? <LoadingCinema /> : null}
    </>
  );
};
